import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button, Input, Label } from "reactstrap";
import emailjs from "@emailjs/browser";
import customFetch from "../../../helpers/fetchClient";

const Support = () => {
    const [user, setUser] = useState(null);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    // 🔹 Récupération de l'utilisateur connecté
    useEffect(() => {
        const fetchMe = async () => {
            try {
                const data = await customFetch("/api/user/me");
                setUser(data);
            } catch (err) {
                console.error("Erreur user connecté :", err);
            }
        };

        fetchMe();
    }, []);

    // 🔹 Envoi Email
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!user || !message) return;

        setLoading(true);

        const templateParams = {
            user_id: user.id,
            user_email: user.email,
            user_name: user.username || "Utilisateur",
            message,
        };

        try {
            await emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                templateParams,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            );

            setSuccess(true);
            setMessage("");
        } catch (err) {
            console.error("Erreur EmailJS :", err);
            alert("Erreur lors de l'envoi du message");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <Row className="justify-content-center">
                    <Col lg={6}>
                        <Card>
                            <CardBody>
                                <h4 className="mb-3">📩 Contacter le support</h4>

                                {success && (
                                    <p className="text-success">
                                        ✅ Message envoyé avec succès !
                                    </p>
                                )}

                                {!user ? (
                                    <p>Chargement de l'utilisateur…</p>
                                ) : (
                                    <form onSubmit={handleSubmit}>
                                        <Label>Email</Label>
                                        <Input
                                            disabled
                                            value={user.email}
                                            className="mb-3"
                                        />

                                        <Label>Message</Label>
                                        <Input
                                            type="textarea"
                                            rows="5"
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            placeholder="Décris ton problème ici…"
                                            required
                                        />

                                        <Button
                                            color="primary"
                                            className="mt-3"
                                            disabled={loading}
                                        >
                                            {loading ? "Envoi…" : "Envoyer"}
                                        </Button>
                                    </form>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Support;
